import { NgIf } from '@angular/common';
import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { IActivityLocation } from '@curbnturf/entities';
import { IonicModule, ModalController } from '@ionic/angular';
import { AddActivityFormComponent } from '../add-activity-form.component';

@Component({
  standalone: true,
  selector: 'curbnturf-activity-form-modal',
  templateUrl: './activity-form-modal.component.html',
  styleUrls: ['./activity-form-modal.component.scss'],
  imports: [forwardRef(() => AddActivityFormComponent), IonicModule, NgIf],
})
export class ActivityFormModalComponent implements OnInit {
  @Input() activity: IActivityLocation;
  @Input() admin: boolean = false;

  showHeader = false;

  constructor(private modalController: ModalController) {}

  ngOnInit() {
    this.showHeader = Capacitor.isNativePlatform();
  }

  closeModal() {
    this.modalController.dismiss();
  }
}
